export default {
  // 右侧菜单项
  menuItems: {
    nodeNote: {
      text: "备注节点",
      shortcut: "alt+V/⌥+V",
    },
    copyAddress: {
      text: "复制地址",
      shortcut: "ctrl+C/⌘+C",
    },
    addCanvas: {
      text: "新建画布",
      shortcut: "alt+G/⌥+G",
    },
    deleteNode: {
      text: "删除节点",
      shortcut: "Delete",
    },
    labelSetting: {
      text: "标签设置",
      submenu: {
        addLabel: "添加标签",
        editLabel: "编辑标签",
        deleteLabel: "删除标签",
      },
    },
    addSurvey: {
      text: "加入调证",
      submenu: {
        ordinarySurvey: "普通调证",
        keySurvey: "重点调证",
      },
    },
    addMonitor: {
      text: "加入监控",
      shortcut: "ctrl+M/⌘+M",
    },
    addBoard: {
      text: "加入看板",
    },
  },
};
